export function autobind(target: any, propKey: string): TypedPropertyDescriptor<any> {
    const func = target[propKey];

    return {
        get() {
            const bound = func.bind(this);

            Object.defineProperty(this, propKey, {
                configurable: true,
                enumerable: false,
                writable: true,
                value: bound
            });

            return bound;
        }
    };
}